import { Link } from "react-router-dom";
import Icons from "./Icons";

export default function LandingSlogan() {
  return (
    <div className="slogan">
      <div className="slogan__text">
        <div className="slogan__text__title">Hulgi vedelkütuste ost ühest keskkonnast</div>
        <div className="slogan__text__content">
          Korralda vedelkütuse hankeid ise tasuta või automatiseeri kogu ostuprotsess.
          Turgoil ühendab turuinfo, mahutid ja tarnijad ühtseks töövooks, et teha paremaid ostuotsuseid.
        </div>
        <div className="slogan__text__btnContainer">
          <Link to="/oil-requests/create" className="slogan__text__button">
            Korralda hange
          </Link>
          <Link to="/contact" className="slogan__text__buttonOutline">
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <div>{Icons.Calendar}</div>
              <div>Broneeri demo</div>
            </div>
          </Link>
        </div>

      </div>
      <div className="slogan__img">
        <img
          style={{ paddingTop: "20px", height: "400px" }}
          src="images/svg/landing-page-2.svg"
          alt="landing-page-icon"
        />
      </div>
    </div>
  );
}
